import React from 'react'
import ContaCorrenteListPageContainer from './ContaCorrenteListPageContainer'

export class ContaCorrenteListPage extends React.Component {
  render() {
    return <ContaCorrenteListPageContainer {...this.props} />
  }
}
